export const SCOPE_SEPERATORS = [
  {
    title: "comma",
    value: ",",
  },
  {
    title: "space",
    value: " ",
  },
  {
    title: "plus",
    value: "+",
  },
];

export const ZOHO_CRM_SCOPES = [
  {
    displayName: "ZohoCRM.modules.pricebooks.READ",
    name: "ZohoCRM.modules.pricebooks.READ",
  },
  {
    displayName: "ZohoCRM.modules.products.CREATE",
    name: "ZohoCRM.modules.products.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.vendors.DELETE",
    name: "ZohoCRM.modules.vendors.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.purchaseorders.CREATE",
    name: "ZohoCRM.modules.purchaseorders.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.activities.WRITE",
    name: "ZohoCRM.modules.activities.WRITE",
  },
  {
    displayName: "ZohoCRM.send_mail.salesorders.WRITE",
    name: "ZohoCRM.send_mail.salesorders.WRITE",
  },
  {
    displayName: "ZohoCRM.functions.execute.READ",
    name: "ZohoCRM.functions.execute.READ",
  },
  {
    displayName: "ZohoCRM.modules.vendors.WRITE",
    name: "ZohoCRM.modules.vendors.WRITE",
  },
  {
    displayName: "ZohoCRM.settings.READ",
    name: "ZohoCRM.settings.READ",
  },
  {
    displayName: "ZohoCRM.modules.quotes.DELETE",
    name: "ZohoCRM.modules.quotes.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.all",
    name: "ZohoCRM.modules.all",
  },
  {
    displayName: "ZohoCRM.modules.deals.DELETE",
    name: "ZohoCRM.modules.deals.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.invoices.DELETE",
    name: "ZohoCRM.modules.invoices.DELETE",
  },
  {
    displayName: "ZohoCRM.settings.emails.READ",
    name: "ZohoCRM.settings.emails.READ",
  },
  {
    displayName: "ZohoCRM.send_mail.invoices.WRITE",
    name: "ZohoCRM.send_mail.invoices.WRITE",
  },
  {
    displayName: "ZohoCRM.settings.layouts.read",
    name: "ZohoCRM.settings.layouts.read",
  },
  {
    displayName: "ZohoCRM.modules.calls.WRITE",
    name: "ZohoCRM.modules.calls.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.pricebooks.CREATE",
    name: "ZohoCRM.modules.pricebooks.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.accounts.WRITE",
    name: "ZohoCRM.modules.accounts.WRITE",
  },
  {
    displayName: "ZohoCRM.bulk.read",
    name: "ZohoCRM.bulk.read",
  },
  {
    displayName: "ZohoCRM.settings.record_locking_configurations.Create",
    name: "ZohoCRM.settings.record_locking_configurations.Create",
  },
  {
    displayName: "ZohoCRM.send_mail.accounts.WRITE",
    name: "ZohoCRM.send_mail.accounts.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.custom.DELETE",
    name: "ZohoCRM.modules.custom.DELETE",
  },
  {
    displayName: "ZohoCRM.settings.layouts.READ",
    name: "ZohoCRM.settings.layouts.READ",
  },
  {
    displayName: "ZohoCRM.modules.Leads.CREATE",
    name: "ZohoCRM.modules.Leads.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.events.READ",
    name: "ZohoCRM.modules.events.READ",
  },
  {
    displayName: "zohocrm.functions.execute.CREATE",
    name: "zohocrm.functions.execute.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.leads.WRITE",
    name: "ZohoCRM.modules.leads.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.ALL",
    name: "ZohoCRM.modules.ALL",
  },
  {
    displayName: "ZohoCRM.templates.inventory.READ",
    name: "ZohoCRM.templates.inventory.READ",
  },
  {
    displayName: "ZohoCRM.settings.extensions.ALL",
    name: "ZohoCRM.settings.extensions.ALL",
  },
  {
    displayName: "ZohoCRM.modules.cases.CREATE",
    name: "ZohoCRM.modules.cases.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.leads.CREATE",
    name: "ZohoCRM.modules.leads.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.cases.READ",
    name: "ZohoCRM.modules.cases.READ",
  },
  {
    displayName: "ZohoCRM.modules.campaigns.DELETE",
    name: "ZohoCRM.modules.campaigns.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.contacts.WRITE",
    name: "ZohoCRM.modules.contacts.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.invoices.CREATE",
    name: "ZohoCRM.modules.invoices.CREATE",
  },
  {
    displayName: "ZohoCRM.settings.currencies.read",
    name: "ZohoCRM.settings.currencies.read",
  },
  {
    displayName: "ZohoCRM.modules.solutions.CREATE",
    name: "ZohoCRM.modules.solutions.CREATE",
  },
  {
    displayName: "ZohoCRM.send_mail.quotes.WRITE",
    name: "ZohoCRM.send_mail.quotes.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.notes.ALL",
    name: "ZohoCRM.modules.notes.ALL",
  },
  {
    displayName: "ZohoCRM.modules.activities.DELETE",
    name: "ZohoCRM.modules.activities.DELETE",
  },
  {
    displayName: "ZohoCRM.share.all",
    name: "ZohoCRM.share.all",
  },
  {
    displayName: "ZohoCRM.modules.deals.WRITE",
    name: "ZohoCRM.modules.deals.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.contacts.CREATE",
    name: "ZohoCRM.modules.contacts.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.purchaseorders.DELETE",
    name: "ZohoCRM.modules.purchaseorders.DELETE",
  },
  {
    displayName: "ZohoCRM.signals.ALL",
    name: "ZohoCRM.signals.ALL",
  },
  {
    displayName: "ZohoCRM.modules.tasks.CREATE",
    name: "ZohoCRM.modules.tasks.CREATE",
  },
  {
    displayName: "ZohoCRM.settings.workflow.ALL",
    name: "ZohoCRM.settings.workflow.ALL",
  },
  {
    displayName: "ZohoCRM.users.ALL",
    name: "ZohoCRM.users.ALL",
  },
  {
    displayName: "ZohoCRM.modules.quotes.READ",
    name: "ZohoCRM.modules.quotes.READ",
  },
  {
    displayName: "ZohoCRM.modules.tasks.WRITE",
    name: "ZohoCRM.modules.tasks.WRITE",
  },
  {
    displayName: "ZohoCRM.settings.related_lists.all",
    name: "ZohoCRM.settings.related_lists.all",
  },
  {
    displayName: "ZohoCRM.modules.cases.DELETE",
    name: "ZohoCRM.modules.cases.DELETE",
  },
  {
    displayName: "ZohoCRM.send_mail.ALL.CREATE",
    name: "ZohoCRM.send_mail.ALL.CREATE",
  },
  {
    displayName: "ZohoCRM.users.READ",
    name: "ZohoCRM.users.READ",
  },
  {
    displayName: "ZohoCRM.modules.quotes.CREATE",
    name: "ZohoCRM.modules.quotes.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.calls.DELETE",
    name: "ZohoCRM.modules.calls.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.calls.READ",
    name: "ZohoCRM.modules.calls.READ",
  },
  {
    displayName: "ZohoCRM.modules.salesorders.DELETE",
    name: "ZohoCRM.modules.salesorders.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.tasks.READ",
    name: "ZohoCRM.modules.tasks.READ",
  },
  {
    displayName: "ZohoCRM.functions.execute.CREATE",
    name: "ZohoCRM.functions.execute.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.events.CREATE",
    name: "ZohoCRM.modules.events.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.salesorders.WRITE",
    name: "ZohoCRM.modules.salesorders.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.custom.WRITE",
    name: "ZohoCRM.modules.custom.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.zoho_projects.ALL",
    name: "ZohoCRM.modules.zoho_projects.ALL",
  },
  {
    displayName: "ZohoCRM.modules.salesorders.CREATE",
    name: "ZohoCRM.modules.salesorders.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.purchaseorders.WRITE",
    name: "ZohoCRM.modules.purchaseorders.WRITE",
  },
  {
    displayName: "ZohoCRM.send_mail.contacts.WRITE",
    name: "ZohoCRM.send_mail.contacts.WRITE",
  },
  {
    displayName: "ZohoCRM.settings.modules.READ",
    name: "ZohoCRM.settings.modules.READ",
  },
  {
    displayName: "ZohoCRM.settings.roles.ALL",
    name: "ZohoCRM.settings.roles.ALL",
  },
  {
    displayName: "ZohoCRM.modules.tasks.DELETE",
    name: "ZohoCRM.modules.tasks.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.campaigns.CREATE",
    name: "ZohoCRM.modules.campaigns.CREATE",
  },
  {
    displayName: "ZohoCRM.send_mail.leads.WRITE",
    name: "ZohoCRM.send_mail.leads.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.campaigns.READ",
    name: "ZohoCRM.modules.campaigns.READ",
  },
  {
    displayName: "ZohoCRM.settings.webhook.ALL",
    name: "ZohoCRM.settings.webhook.ALL",
  },
  {
    displayName: "ZohoCRM.modules.accounts.READ",
    name: "ZohoCRM.modules.accounts.READ",
  },
  {
    displayName: "ZohoCRM.modules.custom.READ",
    name: "ZohoCRM.modules.custom.READ",
  },
  {
    displayName: "ZohoCRM.modules.salesorders.READ",
    name: "ZohoCRM.modules.salesorders.READ",
  },
  {
    displayName: "ZohoCRM.send_mail.deals.WRITE",
    name: "ZohoCRM.send_mail.deals.WRITE",
  },
  {
    displayName: "ZohoCRM.settings.ALL",
    name: "ZohoCRM.settings.ALL",
  },
  {
    displayName: "ZohoCRM.modules.events.WRITE",
    name: "ZohoCRM.modules.events.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.accounts.CREATE",
    name: "ZohoCRM.modules.accounts.CREATE",
  },
  {
    displayName: "ZohoCRM.org.ALL",
    name: "ZohoCRM.org.ALL",
  },
  {
    displayName: "ZohoCRM.modules.deals.READ",
    name: "ZohoCRM.modules.deals.READ",
  },
  {
    displayName: "ZohoCRM.send_mail.purchaseorders.WRITE",
    name: "ZohoCRM.send_mail.purchaseorders.WRITE",
  },
  {
    displayName: "ZohoCRM.settings.fields.READ",
    name: "ZohoCRM.settings.fields.READ",
  },
  {
    displayName: "ZohoCRM.modules.leads.READ",
    name: "ZohoCRM.modules.leads.READ",
  },
  {
    displayName: "ZohoCRM.templates.email.READ",
    name: "ZohoCRM.templates.email.READ",
  },
  {
    displayName: "ZohoCRM.modules.solutions.DELETE",
    name: "ZohoCRM.modules.solutions.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.custom.CREATE",
    name: "ZohoCRM.modules.custom.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.solutions.READ",
    name: "ZohoCRM.modules.solutions.READ",
  },
  {
    displayName: "ZohoCRM.modules.vendors.READ",
    name: "ZohoCRM.modules.vendors.READ",
  },
  {
    displayName: "ZohoCRM.modules.purchaseorders.READ",
    name: "ZohoCRM.modules.purchaseorders.READ",
  },
  {
    displayName: "ZohoCRM.modules.activities.READ",
    name: "ZohoCRM.modules.activities.READ",
  },
  {
    displayName: "ZohoCRM.modules.campaigns.WRITE",
    name: "ZohoCRM.modules.campaigns.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.calls.CREATE",
    name: "ZohoCRM.modules.calls.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.deals.CREATE",
    name: "ZohoCRM.modules.deals.CREATE",
  },
  {
    displayName: "ZohoCRM.settings.map_dependency.READ",
    name: "ZohoCRM.settings.map_dependency.READ",
  },
  {
    displayName: "ZohoCRM.Modules.ALL",
    name: "ZohoCRM.Modules.ALL",
  },
  {
    displayName: "ZohoCRM.modules.invoices.WRITE",
    name: "ZohoCRM.modules.invoices.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.quotes.WRITE",
    name: "ZohoCRM.modules.quotes.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.events.DELETE",
    name: "ZohoCRM.modules.events.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.solutions.WRITE",
    name: "ZohoCRM.modules.solutions.WRITE",
  },
  {
    displayName: "zohocrm.functions.execute.READ",
    name: "zohocrm.functions.execute.READ",
  },
  {
    displayName: "ZohoCRM.modules.vendors.CREATE",
    name: "ZohoCRM.modules.vendors.CREATE",
  },
  {
    displayName: "ZohoCRM.modules.products.DELETE",
    name: "ZohoCRM.modules.products.DELETE",
  },
  {
    displayName: "ZohoCRM.Files.READ",
    name: "ZohoCRM.Files.READ",
  },
  {
    displayName: "ZohoSearch.securesearch.READ",
    name: "ZohoSearch.securesearch.READ",
  },
  {
    displayName: "ZohoCRM.modules.Leads.WRITE",
    name: "ZohoCRM.modules.Leads.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.products.WRITE",
    name: "ZohoCRM.modules.products.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.accounts.DELETE",
    name: "ZohoCRM.modules.accounts.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.entity_scores.READ",
    name: "ZohoCRM.modules.entity_scores.READ",
  },
  {
    displayName: "ZohoWriter.Merge.ALL",
    name: "ZohoWriter.Merge.ALL",
  },
  {
    displayName: "ZohoCRM.modules.contacts.DELETE",
    name: "ZohoCRM.modules.contacts.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.pricebooks.WRITE",
    name: "ZohoCRM.modules.pricebooks.WRITE",
  },
  {
    displayName: "ZohoCRM.settings.global_picklist.ALL",
    name: "ZohoCRM.settings.global_picklist.ALL",
  },
  {
    displayName: "ZohoCRM.modules.products.READ",
    name: "ZohoCRM.modules.products.READ",
  },
  {
    displayName: "ZohoCRM.modules.cases.WRITE",
    name: "ZohoCRM.modules.cases.WRITE",
  },
  {
    displayName: "ZohoCRM.modules.pricebooks.DELETE",
    name: "ZohoCRM.modules.pricebooks.DELETE",
  },
  {
    displayName: "ZohoCRM.settings.unsubscribe.ALL",
    name: "ZohoCRM.settings.unsubscribe.ALL",
  },
  {
    displayName: "ZohoCRM.modules.invoices.READ",
    name: "ZohoCRM.modules.invoices.READ",
  },
  {
    displayName: "ZohoCRM.coql.READ",
    name: "ZohoCRM.coql.READ",
  },
  {
    displayName: "ZohoCRM.modules.leads.DELETE",
    name: "ZohoCRM.modules.leads.DELETE",
  },
  {
    displayName: "ZohoCRM.modules.contacts.READ",
    name: "ZohoCRM.modules.contacts.READ",
  },
  {
    displayName: "ZohoCRM.Files.CREATE",
    name: "ZohoCRM.Files.CREATE",
  },
  {
    displayName: "ZohoCRM.send_mail.custom.WRITE",
    name: "ZohoCRM.send_mail.custom.WRITE",
  },
  {
    displayName: "ZohoSearch.securesearch.READ",
    name: "ZohoSearch.securesearch.READ",
  },
];

export const ZOHO_AUTH_SCOPES = [
  {
    displayName: "ZohoSearch.securesearch.READ",
    name: "ZohoSearch.securesearch.READ",
  },
  { displayName: "ZohoCRM.users.CREATE", name: "ZohoCRM.users.CREATE" },
  { displayName: "ZohoCRM.users.READ", name: "ZohoCRM.users.READ" },
  { displayName: "ZohoCRM.users.UPDATE", name: "ZohoCRM.users.UPDATE" },
  { displayName: "ZohoCRM.org.READ", name: "ZohoCRM.org.READ" },
  { displayName: "ZohoCRM.org.UPDATE", name: "ZohoCRM.org.UPDATE" },
  { displayName: "ZohoCRM.settings.CREATE", name: "ZohoCRM.settings.CREATE" },
  { displayName: "ZohoCRM.settings.READ", name: "ZohoCRM.settings.READ" },
  { displayName: "ZohoCRM.settings.UPDATE", name: "ZohoCRM.settings.UPDATE" },
  { displayName: "ZohoCRM.coql.READ", name: "ZohoCRM.coql.READ" },
  { displayName: "ZohoCRM.modules.CREATE", name: "ZohoCRM.modules.CREATE" },
  { displayName: "ZohoCRM.modules.READ", name: "ZohoCRM.modules.READ" },
  { displayName: "ZohoCRM.modules.UPDATE", name: "ZohoCRM.modules.UPDATE" },
  ...ZOHO_CRM_SCOPES,
];

export const ZOHO_BOOKS_SCOPES = [
  {
    displayName: "ZohoBooks.accountants.All",
    name: "ZohoBooks.accountants.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.accountants.CREATE",
    name: "ZohoBooks.accountants.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.accountants.READ",
    name: "ZohoBooks.accountants.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.accountants.UPDATE",
    name: "ZohoBooks.accountants.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.banking.All",
    name: "ZohoBooks.banking.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.banking.CREATE",
    name: "ZohoBooks.banking.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.banking.READ",
    name: "ZohoBooks.banking.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.banking.UPDATE",
    name: "ZohoBooks.banking.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.bills.All",
    name: "ZohoBooks.bills.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.bills.CREATE",
    name: "ZohoBooks.bills.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.bills.READ",
    name: "ZohoBooks.bills.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.bills.UPDATE",
    name: "ZohoBooks.bills.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.clientbuildadmin.All",
    name: "ZohoBooks.clientbuildadmin.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.compositeitems.All",
    name: "ZohoBooks.compositeitems.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.compositeitems.READ",
    name: "ZohoBooks.compositeitems.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.contacts.All",
    name: "ZohoBooks.contacts.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.contacts.CREATE",
    name: "ZohoBooks.contacts.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.contacts.READ",
    name: "ZohoBooks.contacts.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.contacts.UPDATE",
    name: "ZohoBooks.contacts.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.creditnotes.All",
    name: "ZohoBooks.creditnotes.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.creditnotes.CREATE",
    name: "ZohoBooks.creditnotes.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.creditnotes.READ",
    name: "ZohoBooks.creditnotes.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.creditnotes.UPDATE",
    name: "ZohoBooks.creditnotes.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.customerpayments.All",
    name: "ZohoBooks.customerpayments.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.customerpayments.CREATE",
    name: "ZohoBooks.customerpayments.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.customerpayments.READ",
    name: "ZohoBooks.customerpayments.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.customerpayments.UPDATE",
    name: "ZohoBooks.customerpayments.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.custommodules.ALL",
    name: "ZohoBooks.custommodules.ALL",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.custommodules.All",
    name: "ZohoBooks.custommodules.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.debitnotes.All",
    name: "ZohoBooks.debitnotes.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.debitnotes.CREATE",
    name: "ZohoBooks.debitnotes.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.debitnotes.READ",
    name: "ZohoBooks.debitnotes.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.debitnotes.UPDATE",
    name: "ZohoBooks.debitnotes.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.documents.All",
    name: "ZohoBooks.documents.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.estimates.All",
    name: "ZohoBooks.estimates.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.estimates.CREATE",
    name: "ZohoBooks.estimates.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.estimates.READ",
    name: "ZohoBooks.estimates.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.estimates.UPDATE",
    name: "ZohoBooks.estimates.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.expenses.All",
    name: "ZohoBooks.expenses.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.expenses.CREATE",
    name: "ZohoBooks.expenses.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.expenses.READ",
    name: "ZohoBooks.expenses.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.expenses.UPDATE",
    name: "ZohoBooks.expenses.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.export.All",
    name: "ZohoBooks.export.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.fullaccess.all",
    name: "ZohoBooks.fullaccess.all",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.import.All",
    name: "ZohoBooks.import.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.incomingwebhooks.All",
    name: "ZohoBooks.incomingwebhooks.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.incomingwebhooks.CREATE",
    name: "ZohoBooks.incomingwebhooks.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.incomingwebhooks.READ",
    name: "ZohoBooks.incomingwebhooks.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.integrations.All",
    name: "ZohoBooks.integrations.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.inventoryadjustments.All",
    name: "ZohoBooks.inventoryadjustments.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.inventoryadjustments.CREATE",
    name: "ZohoBooks.inventoryadjustments.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.inventoryadjustments.READ",
    name: "ZohoBooks.inventoryadjustments.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.invoices.All",
    name: "ZohoBooks.invoices.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.invoices.CREATE",
    name: "ZohoBooks.invoices.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.invoices.READ",
    name: "ZohoBooks.invoices.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.invoices.UPDATE",
    name: "ZohoBooks.invoices.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.items.All",
    name: "ZohoBooks.items.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.items.READ",
    name: "ZohoBooks.items.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.others.All",
    name: "ZohoBooks.others.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.packages.All",
    name: "ZohoBooks.packages.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.partnersapi.All",
    name: "ZohoBooks.partnersapi.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.picklists.All",
    name: "ZohoBooks.picklists.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.projects.All",
    name: "ZohoBooks.projects.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.projects.CREATE",
    name: "ZohoBooks.projects.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.projects.READ",
    name: "ZohoBooks.projects.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.projects.UPDATE",
    name: "ZohoBooks.projects.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.purchaseorders.All",
    name: "ZohoBooks.purchaseorders.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.purchaseorders.CREATE",
    name: "ZohoBooks.purchaseorders.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.purchaseorders.READ",
    name: "ZohoBooks.purchaseorders.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.purchaseorders.UPDATE",
    name: "ZohoBooks.purchaseorders.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.purchasereceives.All",
    name: "ZohoBooks.purchasereceives.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.reports.All",
    name: "ZohoBooks.reports.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.salesorders.All",
    name: "ZohoBooks.salesorders.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.salesorders.CREATE",
    name: "ZohoBooks.salesorders.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.salesorders.READ",
    name: "ZohoBooks.salesorders.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.salesorders.UPDATE",
    name: "ZohoBooks.salesorders.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.salesreturnreceives.All",
    name: "ZohoBooks.salesreturnreceives.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.salesreturns.All",
    name: "ZohoBooks.salesreturns.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.settings.All",
    name: "ZohoBooks.settings.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.settings.CREATE",
    name: "ZohoBooks.settings.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.settings.DELETE",
    name: "ZohoBooks.settings.DELETE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.settings.READ",
    name: "ZohoBooks.settings.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.settings.UPDATE",
    name: "ZohoBooks.settings.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.shipmentorders.All",
    name: "ZohoBooks.shipmentorders.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.signals.CREATE",
    name: "ZohoBooks.signals.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.signals.READ",
    name: "ZohoBooks.signals.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.transferorders.All",
    name: "ZohoBooks.transferorders.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.vendorpayments.All",
    name: "ZohoBooks.vendorpayments.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.vendorpayments.CREATE",
    name: "ZohoBooks.vendorpayments.CREATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.vendorpayments.READ",
    name: "ZohoBooks.vendorpayments.READ",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.vendorpayments.UPDATE",
    name: "ZohoBooks.vendorpayments.UPDATE",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.warehouses.All",
    name: "ZohoBooks.warehouses.All",
    isHidden: false,
  },
  {
    displayName: "ZohoBooks.warehouses.READ",
    name: "ZohoBooks.warehouses.READ",
    isHidden: false,
  },
];

export const ZOHO_SCOPES = [];
export const CLIQ_SCOPES = [];
